<!-- Side Structure -->
<template>
    <div class="sidebar" :class="sidebarSelectedFilter.class">
        {{ info }}
        <vue-perfect-scrollbar class="scroll-area" :settings="settings">
            <v-toolbar flat class="transparent scroll-area navigation">
                <v-list>
                    <app-logo></app-logo>
                    <v-divider></v-divider>
                    <template v-for="(category, key) in filter_menu_by_perms">
                        <div :key="key">
                            <v-btn
                                v-if="key == 'sub_menu'"
                                class="pl-4 mb-2 clickable py-4 elevation-0 nav-back-hover text-none"
                                style="font-size: 16px !important"
                                color="primary"
                                block
                                @mouseup.left="goMainMenu()"
                            >
                                <div class="mr-auto white--text">
                                    <v-icon class="mr-1 dark">navigate_before</v-icon>
                                    <!-- {{ $t('lang.go_back') }} -->
                                    {{ $t("lang.leave") + " " + $t(`lang.${category[0].menu_title}`) }}
                                </div>
                            </v-btn>

                            <template v-for="item in category">
                                <!-- IF ITEM HAS SUBITEMS LIST GROUP-->
                                <template v-if="item.items != null">
                                    <v-list-group :key="item.title" no-action active-class="v-list__group--active" :value="isActiveMenu(item.path)">
                                        <v-list-tile slot="activator" @click="toggleDrawers()">
                                            <v-list-tile-content class="pl-4 pr-1">
                                                <div style="display: flex; align-items: center">
                                                    <v-icon class="mr-2" :style="{ 'font-size': '1.2rem' }">{{ item.action }}</v-icon>
                                                    <div style="height: 100%">{{ textTruncate($t(item.title)) }}</div>
                                                </div>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <div v-for="subItem in item.items">
                                            <v-list-tile
                                                v-if="subItem.menu == null"
                                                v-bind:key="subItem.title"
                                                :to="!subItem.exact ? `/${getCurrentAppLayoutHandler() + subItem.path}` : subItem.path"
                                                @click="toggleDrawers()"
                                                active-class="v-list__tile--active"
                                                :value="isActiveMenu(subItem.path)"
                                            >
                                                <v-list-tile-content class="pl-3 pr-1">
                                                    <div style="display: flex; align-items: center">
                                                        <v-icon :class="subItem.icon_class" class="mr-2" :style="{ 'font-size': '1.2rem' }">{{
                                                            subItem.action
                                                        }}</v-icon>
                                                        <div>{{ textTruncate($t(subItem.title)) }}</div>
                                                    </div>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile
                                                v-else
                                                @click="openMenu(subItem.menu)"
                                                :key="subItem.path"
                                                :class="subItem.class"
                                                active-class="v-list__tile--active"
                                                :value="isActiveMenu(subItem.path)"
                                            >
                                                <v-list-tile-content class="pl-3 pr-1">
                                                    <div style="display: flex; align-items: center">
                                                        <v-icon :class="subItem.icon_class" class="mr-2" :style="{ 'font-size': '1.2rem' }">{{
                                                            subItem.action
                                                        }}</v-icon>
                                                        <div>{{ textTruncate($t(subItem.title)) }}</div>
                                                    </div>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </div>
                                    </v-list-group>
                                    <v-divider v-if="item.divider == true"></v-divider>
                                </template>
                                <!-- IF ITEM HAS ONE ITEM-->
                                <template v-else>
                                    <v-list-tile
                                        v-if="item.menu"
                                        @click="openMenu(item.menu)"
                                        :key="item.path"
                                        :class="item.class"
                                        active-class="v-list__tile--active"
                                        :value="isActiveMenu(item.path)"
                                    >
                                        <v-list-tile-content class="pl-4 pr-1">
                                            <div style="display: flex; align-items: center">
                                                <v-icon :class="item.icon_class" class="mr-2" :style="{ 'font-size': '1.2rem' }">{{ item.action }}</v-icon>
                                                <div>{{ textTruncate($t(item.title)) }}</div>
                                            </div>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <!-- IF ITEM HAS NO MENU GO TO PATH-->
                                    <v-list-tile
                                        v-else
                                        :to="
                                            !item.exact
                                                ? `/${getCurrentAppLayoutHandler() + item.path}`
                                                : $route.name == item.name
                                                ? { name: item.name, query: $route.query }
                                                : item.path
                                        "
                                        :key="item.path"
                                        :class="item.class"
                                        @click="toggleDrawers()"
                                        active-class="v-list__tile--active"
                                        :value="isActiveMenu(item.path)"
                                    >
                                        <v-list-tile-content class="pl-4 pr-1">
                                            <div style="display: flex; align-items: center">
                                                <v-icon :class="item.icon_class" class="mr-2" :style="{ 'font-size': '1.2rem' }">{{ item.action }}</v-icon>
                                                <div style="height: 100%">{{ textTruncate($t(item.title)) }}</div>
                                            </div>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider v-if="item.divider == true"></v-divider>
                                </template>
                            </template>
                        </div>
                    </template>
                </v-list>
            </v-toolbar>
        </vue-perfect-scrollbar>
    </div>
</template>

<script>
import { textTruncate, getCurrentAppLayout } from "Helpers/helpers";
import { mapGetters } from "vuex";
import AppLogo from "Components/AppLogo/AppLogo";
import api from "Api";

export default {
    data() {
        return {
            user_type: null,
            settings: {
                maxScrollbarLength: 160,
            },
            info: null,
        };
    },
    components: {
        AppLogo,
    },
    computed: {
        ...mapGetters(["sidebarSelectedFilter", "menu", "filteredMenu"]),
        isActiveMenu() {
            return (path) => (this.$route.fullPath.includes(path) ? true : false);
        },
        filter_menu_by_perms() {
            let filtered_menu = {};
            let menu_keys = Object.keys(this.menu);
            if (this.current_user) {
                menu_keys.forEach((key, index) => {
                    if (this.menu[key] && (this.menu[key] || []).length > 0) {
                        filtered_menu[key] = this.menu[key].filter((m) => {
                            return !m.module || this.current_user.global.includes(`${m.module}.read`);
                        });
                    }
                });
            }
            return filtered_menu;
        },
    },
    created() {
        //let path = "purchasing";
        //alert(this.$route.fullPath.includes(path));
    },
    mounted() {
        this.$store.dispatch("setActiveMenuGroup", this.$router);
    },
    methods: {
        goMainMenu() {
            this.$store.commit("setMenu", this.$store.getters.employeeMenu);
        },
        textTruncate(text) {
            return textTruncate(text, 30);
        },
        openMenu(menuPassed) {
            this.$store.commit("setMenu", this.$store.getters[menuPassed]);
        },
        getCurrentAppLayoutHandler() {
            return getCurrentAppLayout(this.$router);
        },
        toggleDrawers() {
            if (this.$bp.width < 1300) this.$store.commit("toggleMainMenu", false);
            this.$store.commit("toggleHelpArticleMenuHandler", false);
            this.$store.commit("toggleFilterMenu", false);
        },
    },
};
</script>
